/* @HEADER
 * @version 0.15.943 | 2026-07-15
 * @purpose Full-screen loading overlay shown while an in-place project switch (ZVX-DEV-2745) loads the newly active project's data, so the previous project's boards never flash on screen.
 * @sidecar ProjectSwitchOverlay.tsx.header.md
 * @layer app | @hex _none_ | @ctx project
 * @public false
 * @edit careful
 */

// SpecRefs: ZVX-DEV-2745

import { useMessages } from '../shared/i18n/useMessages'
import { PROJECT_SWITCHER_TESTIDS } from './project-switcher.testids'
import './ProjectSwitchOverlay.css'

interface ProjectSwitchOverlayProps {
  /** Display name of the project being switched into. */
  name: string
}

/** Dimmed, full-screen, theme-aware overlay with a spinner and localized status text. */
export function ProjectSwitchOverlay({ name }: ProjectSwitchOverlayProps) {
  const m = useMessages()
  return (
    <div
      className="project-switch-overlay"
      data-testid={PROJECT_SWITCHER_TESTIDS.switchOverlay}
      role="status"
      aria-live="polite"
    >
      <div className="project-switch-overlay__panel">
        <span className="project-switch-overlay__spinner" aria-hidden="true" />
        <span className="project-switch-overlay__text">{m.projectSwitcher.switchOverlay.opening(name)}</span>
      </div>
    </div>
  )
}
